var _excluded = ["isOpen", "overlayProps", "menuItems", "targetProps", "getMenuProps", "getItemProps", "renderMenuItem", "selectedItems", "highlightedIndex", "addSelectedItem", "removeSelectedItem", "children"],
    _excluded2 = ["style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { isItemSelected } from '../helpers';
import { Menu, MenuItem } from '../layout';

var MultiSelectMenu = function MultiSelectMenu(_ref) {
  var isOpen = _ref.isOpen,
      overlayProps = _ref.overlayProps,
      menuItems = _ref.menuItems,
      targetProps = _ref.targetProps,
      getMenuProps = _ref.getMenuProps,
      getItemProps = _ref.getItemProps,
      _ref$renderMenuItem = _ref.renderMenuItem,
      renderMenuItem = _ref$renderMenuItem === void 0 ? function (props) {
    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      isMultiple: true
    }, props));
  } : _ref$renderMenuItem,
      selectedItems = _ref.selectedItems,
      highlightedIndex = _ref.highlightedIndex,
      addSelectedItem = _ref.addSelectedItem,
      removeSelectedItem = _ref.removeSelectedItem,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Menu, _extends({
    isOpen: isOpen,
    targetProps: targetProps,
    getMenuProps: getMenuProps,
    overlayProps: overlayProps
  }, props), menuItems.map(function (item, index) {
    var isSelected = isItemSelected({
      selectedItems: selectedItems,
      item: item
    });

    var _ref2 = (getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps({
      item: item,
      index: index
    })) || {},
        style = _ref2.style,
        itemProps = _objectWithoutProperties(_ref2, _excluded2);

    return renderMenuItem === null || renderMenuItem === void 0 ? void 0 : renderMenuItem(_objectSpread(_objectSpread({
      key: index,
      style: style
    }, itemProps), {}, {
      onClick: function onClick() {
        if (item.disabled) {
          return;
        }

        isSelected ? removeSelectedItem(item) : addSelectedItem(item);
      },
      text: item === null || item === void 0 ? void 0 : item.label,
      subtext: item === null || item === void 0 ? void 0 : item.subtext,
      isDisabled: item.disabled,
      isHighlighted: highlightedIndex === index,
      isSelected: isSelected
    }));
  }), children);
};

export default MultiSelectMenu;
//# sourceMappingURL=MultiSelectMenu.js.map